export const isPuertoRicoZipCode = (zipCode: string): boolean => {
  if (!zipCode) {
    return false;
  }

  const parsedZipCode = parseInt(zipCode);

  return (parsedZipCode >= 600 && parsedZipCode <= 799) || (parsedZipCode >= 900 && parsedZipCode <= 999);
};
